import { useEffect, useState } from 'react';
import { X } from 'shared/icons';
import { TBtn } from './primitives';
import { useTokens } from './tokens';

export function WarehouseConfigModal({ open, onClose, warehouses, loading, selectedIds, isAllSelected, onApply }) {
    const T = useTokens();
    const [draft, setDraft] = useState(null);

    useEffect(() => {
        if (!open) {
            return;
        }
        // Quando "todos" estiver selecionado (null), inicializa com todos para o usuário poder desmarcar.
        if (isAllSelected) {
            setDraft(warehouses.map((w) => w.id));
        } else {
            setDraft(Array.isArray(selectedIds) ? [...selectedIds] : []);
        }
    }, [open, isAllSelected, selectedIds, warehouses]);

    if (!open) {
        return null;
    }

    const draftSet = new Set((draft || []).map((id) => String(id)));
    const allChecked = warehouses.length > 0 && draftSet.size === warehouses.length;

    const toggle = (id) => {
        setDraft((prev) => {
            const next = new Set((prev || []).map((x) => String(x)));
            const key = String(id);
            if (next.has(key)) {
                next.delete(key);
            } else {
                next.add(key);
            }
            return Array.from(next);
        });
    };

    const toggleAll = () => {
        if (allChecked) {
            setDraft([]);
        } else {
            setDraft(warehouses.map((w) => w.id));
        }
    };

    const handleApply = () => {
        // Se TUDO marcado, salvar como "todos" (null) — comportamento default.
        if (warehouses.length > 0 && draftSet.size === warehouses.length) {
            onApply(null);
        } else {
            onApply(draft);
        }
        onClose?.();
    };

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(0,0,0,0.65)',
                zIndex: 500,
                display: 'grid',
                placeItems: 'center',
                padding: 20,
            }}
        >
            <div
                style={{
                    width: 'min(520px, 100%)',
                    maxHeight: 'calc(100vh - 80px)',
                    background: T.bg,
                    borderRadius: 8,
                    border: `1px solid ${T.line}`,
                    boxShadow: '0 16px 48px rgba(0,0,0,0.32)',
                    display: 'flex',
                    flexDirection: 'column',
                    fontFamily: T.sans,
                    overflow: 'hidden',
                }}
            >
                <div
                    style={{
                        padding: '14px 18px',
                        borderBottom: `1px solid ${T.line}`,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                    }}
                >
                    <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 14, fontWeight: 600, color: T.ink }}>Configurar depósitos Bling</div>
                        <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>
                            Marque quais depósitos somam na coluna de estoque desta tela. A aba de Estoque do produto
                            sempre lista todos.
                        </div>
                    </div>
                    <TBtn variant="ghost" size="xs" onClick={onClose}>
                        <X size={12} />
                    </TBtn>
                </div>

                <div style={{ flex: 1, overflowY: 'auto', padding: '8px 0' }}>
                    {loading ? (
                        <div style={{ padding: '24px 18px', fontSize: 13, color: T.muted, textAlign: 'center' }}>
                            Carregando depósitos...
                        </div>
                    ) : warehouses.length === 0 ? (
                        <div style={{ padding: '24px 18px', fontSize: 13, color: T.muted, textAlign: 'center' }}>
                            Nenhum depósito disponível.
                        </div>
                    ) : (
                        <>
                            <label
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                    padding: '8px 18px',
                                    cursor: 'pointer',
                                    borderBottom: `1px solid ${T.line}`,
                                    background: T.bgSoft,
                                }}
                            >
                                <input type="checkbox" checked={allChecked} onChange={toggleAll} />
                                <span style={{ fontSize: 12, fontWeight: 600, color: T.ink }}>
                                    {allChecked ? 'Desmarcar todos' : 'Selecionar todos'}
                                </span>
                                <span style={{ marginLeft: 'auto', fontSize: 11, color: T.muted, fontFamily: T.mono }}>
                                    {draftSet.size} / {warehouses.length}
                                </span>
                            </label>
                            {warehouses.map((w) => {
                                const checked = draftSet.has(String(w.id));
                                return (
                                    <label
                                        key={w.id}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 10,
                                            padding: '8px 18px',
                                            cursor: 'pointer',
                                            borderBottom: `1px solid ${T.line}`,
                                        }}
                                    >
                                        <input type="checkbox" checked={checked} onChange={() => toggle(w.id)} />
                                        <span style={{ fontSize: 13, color: T.ink, flex: 1 }}>{w.name}</span>
                                        <span style={{ fontSize: 11, color: T.muted, fontFamily: T.mono }}>{w.id}</span>
                                    </label>
                                );
                            })}
                        </>
                    )}
                </div>

                <div
                    style={{
                        padding: '12px 18px',
                        borderTop: `1px solid ${T.line}`,
                        display: 'flex',
                        gap: 8,
                        justifyContent: 'flex-end',
                        background: T.bgSoft,
                    }}
                >
                    <TBtn variant="ghost" size="sm" onClick={onClose}>
                        Cancelar
                    </TBtn>
                    <TBtn variant="primary" size="sm" onClick={handleApply}>
                        Aplicar
                    </TBtn>
                </div>
            </div>
        </div>
    );
}
